import React, { useEffect } from "react";
import { Header } from "Layout/header";
import { translation } from "Helpers/i8n-helper";
import { useSelector } from "react-redux";
// import background from "../../assets/running-frequency.jpg";
import background from "../../assets/improvedRunner2.png";
import logo from '../../assets/images/appicon.png';
import googlePlayLogo from '../../assets/images/downloadGooglePlay.png';
import appStoreLogo from '../../assets/images/downloadAppStore.png';
import facebookLogo from '../../assets/facebook-logo.png';
import appleLogo from '../../assets/apple-logo.png';
import { message, Input, Button } from 'antd';
import { Formik, Form } from 'formik';
import { oAuthLoginSubmit, loginSubmit } from "../../redux/reducers/AuthReducer";
import { useDispatch } from "react-redux";
import { GoogleLogin } from '@react-oauth/google';
import FacebookLogin from 'react-facebook-login/dist/facebook-login-render-props'
import AppleLogin from 'react-apple-login';
import pledgeLogo from '../../assets/pledge-logo.svg';
import jwt_decode from "jwt-decode";
import { useHistory } from "react-router-dom";
import "./styles.css";

function Login() {
  const history = useHistory();
  const t = translation("login");
  const dispatch = useDispatch();
  const { error, loading } = useSelector(state => state?.AuthReducer);

  useEffect(() => {
    if (error) {
      message.error(error);
    }
  }, [error]);

  const login = (data) => {
    dispatch(loginSubmit(data))
  };

  const oauthRegisterLogin = async (data) => {
    if (!data.email && !data.appleIdentityToken) {
      message.error(t('invalidOrUnverifiedEmail'));
      return
    }

    dispatch(oAuthLoginSubmit(data));
  }

  const responseGoogle = (googleResponse) => {
    if (!googleResponse || googleResponse?.error) {
      message.error(t('unableToLoginWithGoogle'));
      return
    }

    oauthRegisterLogin({
      email: googleResponse?.email,
      givenName: googleResponse.given_name,
      photo: googleResponse.picture
    })
  }

  const responseFacebook = (facebookResponse) => {
    if (!facebookResponse?.accessToken) {
      console.log("Facebook error: ", facebookResponse);
      message.error(t('unableToLoginWithFacebook'));
      return
    }

    oauthRegisterLogin({
      email: facebookResponse?.email,
      givenName: facebookResponse?.name,
      photo: facebookResponse.picture?.data.url || ""
    })
  }

  const responseApple = (appleResponse) => {
    if (!appleResponse) {
      message.error(t('unableToLoginWithApple'));
      return
    }

    if (appleResponse?.authorization?.id_token) {
      oauthRegisterLogin({
        appleIdentityToken: appleResponse?.authorization?.id_token
      })
    }
  }

  return (
    <div className="bgimg" style={{ backgroundImage: `url(${background})` }}>
      <div className="koodos-top">
        <img src={logo} className="koodos-dashboard-logo" />

        <div className="koodos-login-sub-logo">
          <span className="koodos-dashboard-text">KOODOS</span>

          {/* <div className="powered-by-div">
            {`${'powered by'} `}
            <img src={pledgeLogo} className="pledge-dashboard-logo" />
          </div> */}
        </div>
      </div>

      <div className="form-div">
        <div className="form-background">
          <Header>
            <span>{t("login")}</span>
          </Header>

          <Formik initialValues={{ email: '', password: '' }} onSubmit={login}>
            {({ errors, touched, handleChange }) => (
              <Form>
                <label>{t('email')}</label>
                <Input
                  name="email"
                  required
                  onChange={handleChange}
                  placeholder={t('email')}
                />
                <p className="error-label">
                  {touched.email && errors.email}
                </p>

                <label>{t('password')}</label>
                <Input
                  name="password"
                  required
                  type='password'
                  onChange={handleChange}
                  placeholder={t('password')}
                />
                <p className="error-label">
                  {touched.password && errors.password}
                </p>

                <Button
                  type="primary"
                  htmlType="submit"
                  disabled={loading}
                  block>
                  {t('login')}
                </Button>
              </Form>
            )}
          </Formik>
        </div>
      </div>

      <div className="oauth-div">
        <div className="google-login-div">
          <GoogleLogin
            useOneTap={false}
            onSuccess={credentialResponse => {
              let decodedProfile = jwt_decode(credentialResponse.credential);
              responseGoogle(decodedProfile)
            }}
            onError={responseGoogle}
          />
        </div>

        <FacebookLogin
          appId={process.env.REACT_APP_FACEBOOK_APP_ID}
          fields="name,email,picture"
          render={renderProps => (
            <div className="facebook-login-div" onClick={renderProps.onClick}>
              <img className="oauth-facebook-logo" src={facebookLogo} />
              <span className="continue-with-google">{t('continueWithFacebook')}</span>
            </div>
          )}
          callback={responseFacebook} />

        <AppleLogin
          usePopup
          clientId={process.env.REACT_APP_APPLE_CLIENT_ID}
          redirectURI={process.env.REACT_APP_LIVE_URL}
          scope="email"
          callback={responseApple}
          render={renderProps => (
            <div className="facebook-login-div" onClick={renderProps.onClick}>
              <img className="oauth-logo" src={appleLogo} />
              <span className="continue-with-google">{t('continueWithApple')}</span>
            </div>
          )}
        />
      </div>

      {/* <div className="app-link-div">
        <a href={process.env.REACT_APP_APP_LINK_ANDROID} target="_blank">
          <img src={googlePlayLogo} />
        </a>

        <a href={process.env.REACT_APP_APP_LINK_IOS} target="_blank">
          <img src={appStoreLogo} />
        </a>
      </div> */}

      <div className="login-footer">
        <div
          onClick={() => window.open(`${process.env.REACT_APP_LIVE_URL}/termsapplegoogle`, '_blank')}
          className="terms-policy-text"
        >
          Terms & Conditions
        </div>

        <div
          onClick={() => window.open(`${process.env.REACT_APP_LIVE_URL}/privacy`, '_blank')}
          className="terms-policy-text">
          Privacy Policy
        </div>
      </div>
    </div>
  );
}

export default Login;
